import { NgxExcelCellEvent } from './ngx-excel-cell.model';
import { Observable } from 'rxjs';

export enum NgxExcelActionScope {
  Excel = 'excel',
  Context = 'context',
  Column = 'column'
}

export interface NgxExcelAction {
  label: string;
  action: string;
  icon: string;
  prefix: boolean;
  actionScope: NgxExcelActionScope;
  disabled: boolean;
  invisible: boolean;
  enabled?: (payload: NgxExcelCellEvent) => boolean;
  visible?: (payload: NgxExcelCellEvent) => boolean;
  execute?: (payload: NgxExcelContextMenuClickedEvent) => Observable<NgxExcelContextChanged[]> | void;
}

export interface NgxExcelContextMenuClickedEvent extends NgxExcelCellEvent {
  action: NgxExcelAction;
}

export interface NgxExcelContextChanged {
  action: string;
  context?: any;
  contexts?: any[];
  relativeContext?: any;
}

export interface NgxExcelContextChangeRecord extends NgxExcelContextChanged { }

export enum NgxExcelContextToggleState {
  Collapse = 'collapse',
  Expand = 'expand'
}

export interface NgxExcelContextToggledEvent extends NgxExcelCellEvent {
  previousState: NgxExcelContextToggleState;
  currentState: NgxExcelContextToggleState;
}
